// extracted by mini-css-extract-plugin
export var grid = "_1e-0";
export var span1 = "_1e-2";
export var span10 = "_1e-b";
export var span10L = "_1e-z";
export var span10M = "_1e-n";
export var span10Xl = "_1e-1b";
export var span11 = "_1e-c";
export var span11L = "_1e-10";
export var span11M = "_1e-o";
export var span11Xl = "_1e-1c";
export var span12 = "_1e-d";
export var span12L = "_1e-11";
export var span12M = "_1e-p";
export var span12Xl = "_1e-1d";
export var span1L = "_1e-q";
export var span1M = "_1e-e";
export var span1Xl = "_1e-12";
export var span2 = "_1e-3";
export var span2L = "_1e-r";
export var span2M = "_1e-f";
export var span2Xl = "_1e-13";
export var span3 = "_1e-4";
export var span3L = "_1e-s";
export var span3M = "_1e-g";
export var span3Xl = "_1e-14";
export var span4 = "_1e-5";
export var span4L = "_1e-t";
export var span4M = "_1e-h";
export var span4Xl = "_1e-15";
export var span5 = "_1e-6";
export var span5L = "_1e-u";
export var span5M = "_1e-i";
export var span5Xl = "_1e-16";
export var span6 = "_1e-7";
export var span6L = "_1e-v";
export var span6M = "_1e-j";
export var span6Xl = "_1e-17";
export var span7 = "_1e-8";
export var span7L = "_1e-w";
export var span7M = "_1e-k";
export var span7Xl = "_1e-18";
export var span8 = "_1e-9";
export var span8L = "_1e-x";
export var span8M = "_1e-l";
export var span8Xl = "_1e-19";
export var span9 = "_1e-a";
export var span9L = "_1e-y";
export var span9M = "_1e-m";
export var span9Xl = "_1e-1a";
export var stretch = "_1e-1";